import { Link, useNavigate } from "react-router-dom";
import { HOME_URL_LOCAL, ORDER_DETAILS_URL_LOCAL } from "../../utility/BaseUrl";
import { useEffect, useState } from "react";
import { FetchOrdersService } from "../../services/MainScreen";

export default function ViewOrders() {
  const navigate = useNavigate();

  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    async function FetchOrder() {
      setLoading(true);
      const res = await FetchOrdersService();
      if (res.status === 200) {
        setOrders(res.result);
      } else {
        console.error(res.message);
      }
      setLoading(false);
    }
    if (orders.length === 0) FetchOrder();
  }, []);

  const handleViewItems = (tracking_code, items) => {
    navigate(ORDER_DETAILS_URL_LOCAL(tracking_code), { state: { items } });
  };

  return (
    <>
      <div className="pagetitle ">
        <ol className="breadcrumb">
          <li>
            <Link to={HOME_URL_LOCAL}> خانه </Link>
          </li>
          <li className="active font-weight-bold"> سفارش‌ها </li>
        </ol>
        <h3>سفارش‌ها</h3>
      </div>
      <div className="content-wrapper no-sidebar ">
        <div className="container-fluid">
          <div className="row">
            <div className="col-xs-12"></div>
            {/* <div className="col-sm-6 table-crud-btn-mtop toolbar margin-bottom">
              <button
                type="button"
                className="btn btn-secondary btn-sm"
                data-toggle="modal"
                data-target="#FormsDownloadConfirm"
              >
                <i className="fa fa-download" />
                <span className="hidden-sm-down">دانلود فایل اکسل</span>
              </button>
            </div> */}
            {/* <form >
            
              <div className="col-xs-6 col-sm-2">
                <div className="form-group">
                  <label>پرداخت:</label>
                  <select
                    className="form-control input-sm    tempDisabled "
                    name="payment"
                    id="payment"
                  >
                    <option value selected="selected">
                      ---
                    </option>
                    <option value="paid">پرداخت شده</option>
                    <option value="unpaid">منتظر پرداخت</option>
                    <option value="cash_on_delivery">پرداخت در محل</option>
                    <option value="refunded">برگشت داده شده</option>
                  </select>
                </div>
              </div>
              <div className="col-xs-6 col-sm-2">
                <div className="form-group">
                  <label>وضعیت:</label>
                  <select
                    className="form-control input-sm    tempDisabled "
                    name="status"
                    id="status"
                  >
                    <option value selected="selected">
                      ---
                    </option>
                    <option value="not_completed">تکمیل نشده</option>
                    <option value="unfulfilled">منتظر بررسی</option>
                    <option value="in_progress">در حال پیگیری</option>
                    <option value="fulfilled">انجام شده</option>
                    <option value="canceled">لغو شده</option>
                  </select>
                </div>
              </div>
            </form> */}
            <div className="col-xs-12 margin-top-sm">
              <div className="table-responsive">
                <table className="table table-crud table-bordered table-striped table-hover">
                  <thead>
                    <tr>
                      <th className="cell-row">کد</th>
                      <th> تاریخ ثبت </th>
                      <th>وضعیت</th>
                      <th>مبلغ کل</th>
                      <th>&nbsp;</th>
                    </tr>
                  </thead>
                  {loading ? (
                    <tbody>
                      <tr>
                        <td colSpan={7}>
                          <loading text="در حال بارگذاری...">
                            <i className="fa fa-refresh fa-spin fa-fw " /> در
                            حال بارگذاری...
                          </loading>
                        </td>
                      </tr>
                    </tbody>
                  ) : (
                    <tbody>
                      {orders.length > 0 ? (
                        orders.map((item, index) => {
                          const {
                            tracking_code,
                            created_at,
                            status,
                            payable_amount,
                            items,
                          } = item;
                          let statusTag;
                          switch (status) {
                            case "Processing":
                              statusTag = (
                                <a
                                  className="label label-default "
                                  href="/user/store/orders?status=not_completed"
                                >
                                  درحال پردازش
                                </a>
                              );
                              break;
                            case "Accepted":
                              statusTag = (
                                <a
                                  className="label label-warning "
                                  href="/user/store/orders?status=unfulfilled"
                                >
                                  تائید شده
                                </a>
                              );
                              break;
                            case "Posted":
                              statusTag = (
                                <a
                                  className="label label-default "
                                  href="/user/store/orders?status=in_progress"
                                >
                                  ارسال شده
                                </a>
                              );
                              break;
                            case "Delivered":
                              statusTag = (
                                <a
                                  className="label label-success "
                                  href="/user/store/orders?status=fulfilled"
                                >
                                  تحویل به مشتری
                                </a>
                              );
                              break;
                            case "Returned":
                              statusTag = (
                                <a
                                  className="label label-danger"
                                  href="/user/store/orders?status=canceled"
                                >
                                  مرجوع شده
                                </a>
                              );
                              break;
                          }
                          return (
                            <tr>
                              <td className="cell-row">{tracking_code}</td>
                              <td>
                                <span
                                  data-toggle="tooltip"
                                  data-original-title="09 آبان 1403 ساعت  16:56"
                                >
                                  {created_at}
                                </span>
                              </td>
                              <td>{statusTag}</td>
                              <td> {payable_amount} </td>
                              <td>
                                <button
                                  className="btn btn-primary"
                                  onClick={() =>
                                    handleViewItems(tracking_code, items)
                                  }
                                >
                                  محصولات این سبد
                                </button>
                              </td>
                              {/*   <td className="cell-icon">
                        <a
                          data-toggle="tooltip"
                          data-original-title="دانلود فایل‌ها"
                          href="/user/store/orders/download"
                        >
                          <i className="fa fa-fw fa-download" />
                        </a>
                        <a
                          data-toggle="tooltip"
                          title
                          data-original-title="مشاهده اطلاعات"
                          href="/user/store/orders/154944937"
                        >
                          <i className="fa fa-fw fa-bars" />
                        </a>
                        <a
                          data-toggle="tooltip"
                          title
                          data-original-title="مشاهده پرداخت‌ها"
                          href="/user/billing/payments?invoice_id=154944937"
                        >
                          <i className="fa fa-fw fa-credit-card" />
                        </a>
                      </td> */}
                            </tr>
                          );
                        })
                      ) : (
                        <tr>
                          <td className="bg-info" colSpan={8}>
                            سفارشی برای نمایش پیدا نشد.
                          </td>
                        </tr>
                      )}
                    </tbody>
                  )}
                </table>
              </div>
            </div>
            {/* <div className="col-xs-12">
              <paging
                page="pagination.page"
                page-size="pagination.size"
                className="ng-isolate-scope"
              >
                <ul className="pagination ">
                  <li title="Previous Page" className=" disabled"></li>

                  <li className=" active">
                    {" "}
                    <a href="/user/store/orders?page=1">1</a>{" "}
                  </li>
                  <li className=" disabled">
                    {" "}
                    <a>&gt;</a>{" "}
                  </li>
                </ul>
              </paging> 
            </div>*/}
          </div>
        </div>
      </div>
      {/* <div className="modal modal-center modal-gray " id="FormsDownloadConfirm">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-icon">
              <i className="fa fa-download" />
            </div>
            <div className="modal-body">
              <h4>دانلود فایل اکسل</h4>
              <p>آیا مایل به دانلود فایل اکسل صورتحساب‌ها هستید؟</p>
            </div>
            <div className="modal-footer">
              <div className="row">
                <div className="col-xs-6 col-sm-6">
                  <button
                    type="button"
                    className="btn btn-block btn-default tempDisabled"
                    data-dismiss="modal"
                  >
                    انصراف
                  </button>
                </div>
                <div className="col-xs-6 col-sm-6">
                  <button
                    type="button"
                    ng-click="export(); hideModal(); goTop();"
                    className="btn btn-block btn-default tempDisabled"
                  >
                    دانلود فایل
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="modal modal-center modal-red " id="FormsDeleteConfirm">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-icon">
              <i className="fa fa-trash" />
            </div>
            <div className="modal-body">
              <h4>حذف سفارش</h4>
              <p>آیا مایل به حذف سفارش هستید؟</p>
            </div>
            <div className="modal-footer">
              <div className="row">
                <div className="col-xs-6 col-sm-6">
                  <button
                    type="button"
                    className="btn btn-block btn-default tempDisabled"
                    data-dismiss="modal"
                  >
                    انصراف
                  </button>
                </div>
                <div className="col-xs-6 col-sm-6">
                  <button
                    type="button"
                    className="btn btn-block btn-danger tempDisabled"
                    ng-click="delete(); hideModal();"
                  >
                    حذف سفارش
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> */}
    </>
  );
}
